
<div
  class="card container my-5 py-4 px-3 px-md-4 rounded-4 shadow-lg"
  *ngFor="let item of data.details.services; let i = index"
>
  <div class="row g-4 align-items-center justify-content-center">
    <div class="col-12 me-1 mb-3" *ngIf="i === 0 && data?.details.title">
      <h3 class="section-title text-center mb-4">
        {{ data.details.title.split(" ")[0] }}
        <span>{{ data.details.title.split(" ").slice(1).join(" ") }}</span>
      </h3>
    </div>

    <div class="col-12 col-md-6 d-flex flex-column justify-content-center align-items-end">
      <div class="summary-content" [innerHTML]="item.summary"></div>
      <a
        class="btn btn-primary px-4 py-2 rounded-pill mt-3 align-self-start"
        [href]="getDetailsUrl(item)"
        *ngIf="data.details.isDetails"
      >
        {{ "details" | translate }}
      </a>
    </div>

    <div class="col-12 col-md-5">
      <div class="row g-3">
        <div class="col-6" *ngFor="let img of [item.imageIconPath, item.secondImageIconPath]">
          <img
            class="service-img rounded-4 w-100"
            [src]="img"
            [alt]="item.imageAlt"
            loading="lazy"
            (click)="openImage(img)"
            data-bs-toggle="modal"
            data-bs-target="#imageModal"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="imageModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-body p-0 position-relative">
        <button
          type="button"
          class="btn-close position-absolute top-0 end-0 m-3"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
        <img
          [src]="selectedImage"
          class="img-fluid rounded-4 w-100"
          alt="Preview"
        />
      </div>
    </div>
  </div>
</div>
